// extracted by mini-css-extract-plugin
export default {"drawer":"EmailDelivery_drawer__TNfq3","spin":"EmailDelivery_spin__fB0Rb","tabs":"EmailDelivery_tabs__RVFBE","tabPane":"EmailDelivery_tabPane__JCyc2"};